import Model from "./Model";
import Payment from "./Payment";

export default class Order extends Model {
    resource() {
        return "orders";
    }

    relations() {
        return {
            payments: Payment
        };
    }

    primaryKey() {
        return "uuid";
    }

    async refresh() {
        const { data } = await this.$http.get(this.endpoint() + "?refresh");
        return new Order(data.data);
    }
}